<template>
  <v-dialog
    v-model="value.visibilidade"
    persistent
    max-width="50%"
  >
    <v-card>
      <v-card-title class="primary--text">{{ value.titulo }}</v-card-title>

      <v-card-text>
        <p>{{ value.texto }}</p>
        <app-alert
          v-if="value.observasoes"
          color="grey"
          icon="info"
          :message="value.observasoes"
        />
      </v-card-text>

      <v-card-actions v-if="value.acoes">
        <v-spacer />
        <v-btn
          v-for="(acao, index) in value.acoes"
          :key="index"
          :color="acao.cor"
          text
          @click="executarEFechar(acao.funcao())"
        >
          {{ acao.texto }}
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer />
        <v-btn
          color="secondary"
          text
          @click="executarEFechar()"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AppAlert from '@/components/core/AppAlert';

export default {
  name: 'DialogInfo',

  components: { AppAlert },

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        titulo: '',
        texto: '',
        visibilidade: false,
        acoes: {
          confirm: {
            texto: 'OK',
            cor: 'secondary',
          },
        },
      }),
    },
  },

  methods: {
    executarEFechar(funcao) {
      if (funcao) {
        funcao();
      }
      this.value.visibilidade = false;
    },
  },
};
</script>
